import { FormSection } from '@/containers/forms/FormSection'
import type { BaseContainerProps } from '.'
import { ParametersForm } from '../forms/ParametersForm'

export const Parameters = (props: BaseContainerProps) => {
  return (
    <FormSection {...props}>
      <ParametersForm />
    </FormSection>
  )
}